const store ={
    cart:[],
    favourite:[],
    order:[],
    searchValue:"",

}

export default store;